import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import StarIcon from '@mui/icons-material/StarBorder';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import Modal from '@mui/material/Modal';



function Homepage() {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const styleModal = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      // width: 400,
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
      p: 4,
    };

    return(
        <React.Fragment>
        <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
        <CssBaseline />
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModal}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfNFQqCNc0qu2mN0pKBV6SxGhksi2gmJLg3XLZT1JKL0OxzLw/viewform?embedded=true" width="640" height="670" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </Typography>
          </Box>
        </Modal>
        <AppBar
          position="static"
          color="default"
          elevation={0}
          sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
        >
          <Toolbar sx={{ flexWrap: 'wrap' }}>
            <Typography variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
              Checkpoints App
            </Typography>
            <nav>
              {/* <Link
                variant="button"
                color="text.primary"
                href="/"
                sx={{ my: 1, mx: 1.5 }}
              >
                Home
              </Link>
              <Link
                variant="button"
                color="text.primary"
                href="/docs"
                sx={{ my: 1, mx: 1.5 }}
              >
                Docs
              </Link>
              <Link
                variant="button"
                color="text.primary"
                href="/dashboard"
                sx={{ my: 1, mx: 1.5 }}
              >
                Dashboard
              </Link> */}
            </nav>
            <Button onClick={handleOpen} variant="outlined" sx={{ my: 1, mx: 1.5 }}>
              Sign Up
            </Button>
          </Toolbar>
        </AppBar>
        <Container style={{marginTop: "20px"}}>
          <Grid container>
            <Grid item xs={12}>
              <h1>Checkpoints App</h1>
              <p>Add checkpoints in code across your entire stack. Measure the <strong>speed</strong> of all of your processes in a single dashboard.</p>
              <Button onClick={handleOpen} variant="contained" size="large" sx={{ my: 1, mx: 1.5 }}>
                Sign Up Today
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <img src={require('./dashboard.png')} class="img-fluid" style={{maxWidth: "981px"}} />
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <h1>How to add checkpoints in your code?</h1>
              <p>As easy as writing a <code>print()</code> statement, simply use one of the clients as shown below and start adding checkpoints in your code.</p>
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={4}>
            <h1>Bash</h1>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                bash checkpoints.sh "process1" start<br />
                bash checkpoints.sh checkpoint "checkpoint1"<br />
                bash checkpoints.sh checkpoint "checkpoint2"<br />
                bash checkpoints.sh "process1" end<br />
                </code>
            </Box>
            </Grid>
            <Grid item xs={4}>
            <h1>Python</h1>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                checkpoints = CheckpointsApp()<br />
                <br />
                checkpoints.start("process1")<br />
                checkpoints.checkpoint("checkpoint1")<br />
                checkpoints.checkpoint("checkpoint2")<br />
                checkpoints.end("process1")<br />
                </code>
            </Box>
            </Grid>
            <Grid item xs={4}>
            <h1>JavaScript</h1>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                {"import {start, checkpoint, end} from 'checkpointsapp';"}<br />
                {"start('process1');"}<br />
                {"checkpoint('checkpoint1');"}<br />
                {"checkpoint('checkpoint2');"}<br />
                {"end('process1');"}<br />
                </code>
            </Box>
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <h2>Example: Adding checkpoints for multiple processes</h2>
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={2}></Grid>
            <Grid item xs={8}>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                checkpoints = CheckpointsApp()<br />
                ...<br />
                checkpoints.start("process1")<br />
                checkpoints.start("process2")<br />
                ...<br />
                checkpoints.process("process2")checkpoint("checkpoint1")<br />
                checkpoints.process("process1")checkpoint("checkpoint1")<br />
                ...<br />
                checkpoints.end("process1")<br />
                checkpoints.end("process2")<br />
                </code>
            </Box>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
        </Container>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <h2>Example: Adding checkpoints across stack</h2>
            </Grid>
          </Grid>
          <Grid container spacing={0}>
          <Grid item xs={2}></Grid>
            <Grid item xs={8}>
            <Box
                component="span"
                sx={{
                display: 'block',
                p: 1,
                m: 1,
                bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                color: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                border: '1px solid',
                borderColor: (theme) =>
                    theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
                borderRadius: 2,
                fontSize: '0.875rem',
                // fontWeight: '700',
                }}
            >
                <code>
                # python (backend)<br />
                checkpoints = CheckpointsApp()<br />
                checkpoints.start("process1")<br />
                checkpoints.process("process2")checkpoint("checkpoint1")<br />
                <br />
                // JS (frontend)<br />
                {"import {checkpoint, end} from 'checkpointsapp';"}<br />
                checkpoint("checkpoint2", "process1")<br />
                end("process1")<br />
                </code>
            </Box>
            </Grid>
            <Grid item xs={2}></Grid>
          </Grid>
        </Container>
        <Container style={{marginTop: "20px", marginBottom: "40px"}}>
          <Grid container>
            <Grid item xs={12}>
              <h1>Want this for your stack?</h1>
              <Button onClick={handleOpen} variant="contained" size="large" sx={{ my: 1, mx: 1.5 }}>
                Sign Up Now
              </Button>
            </Grid>
          </Grid>
        </Container>
      </React.Fragment>
    );
}


export default Homepage;